package com.patronat.top.client.platform

import kotlinx.browser.window

actual fun shareText(title: String, text: String) {
    val navigator = window.navigator.asDynamic()
    if (js("typeof navigator !== 'undefined' && typeof navigator.share === 'function'") as Boolean) {
        val data = js("{}")
        data.title = title
        data.text = text
        data.url = text.lineSequence().lastOrNull { it.startsWith("http") } ?: text
        runCatching {
            navigator.share(data)
        }.onFailure {
            fallbackShare(title, text)
        }
    } else {
        fallbackShare(title, text)
    }
}

private fun fallbackShare(title: String, text: String) {
    window.open("mailto:?subject=${encode(title)}&body=${encode(text)}", "_blank")
}

private fun encode(value: String): String {
    return js("encodeURIComponent(value)") as String
}
